// extracted by mini-css-extract-plugin
export default {"container":"OTPInput__container___w7tXy","box":"OTPInput__box___emEtD"};